import { memo, useEffect, useRef } from "react";
import { generateRandomNumber } from "../../../utils";

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleBackMusic } from "../../../modules/user";

const music = {
    game: [
        'koto_1.mp3',
        'koto_10.mp3',
        'koto_2.mp3',
        'koto_3.mp3',
        'koto_4.mp3',
        'koto_5.mp3',
        'koto_6.mp3',
        'koto_7.mp3',
        'koto_8.mp3',
        'koto_9.mp3',
    ],
    think: [
        'gamelan_1.mp3',
        'gamelan_2.mp3',
        'gamelan_3.mp3',
    ]
};

const CONTROLS = false;

const BackMusic = ({ source, type = 'game', vol = 0.1, back_music = true }) => {

    const audioRef = useRef();

    useEffect(() => {
        if (audioRef && audioRef.current) audioRef.current.volume = vol;

        return () => {
            if (audioRef && audioRef.current) audioRef.current.pause();
        };
    }, []);

    useEffect(() => {
        if (audioRef && audioRef.current) audioRef.current.volume = vol;
    }, [back_music]);


    if (!source || !back_music) return null;
    else if (source === 'random') {
        const mList = music[type];
        const idx = generateRandomNumber(0, mList.length - 1, null);
        const aMusic = mList[idx];
        // console.log('aMusic:', idx, aMusic);

        return (<>
            <audio ref={audioRef} controls={CONTROLS} src={`./static/backmusic/${aMusic}`} autoPlay={true} loop={true} />
        </>);
    } else {
        // console.log('source:', source);
        return <>
            <audio ref={audioRef} controls={CONTROLS} src={`./static/backmusic/${source}`} autoPlay={true} loop={true} />
        </>;
    }
}


const mapStateToProps = ({ user, response, subscription }) => ({
    back_music: user.back_music,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
        },
        dispatch
    );

export default memo(connect(mapStateToProps, mapDispatchToProps)(BackMusic));
